if (!customElements.get('theme-image-banner')) {
  customElements.define('theme-image-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.track = this.querySelector('.theme-image-banner__track');
      this.slides = [...this.querySelectorAll('[data-banner-slide]')];
      this.pages = [...this.querySelectorAll('[data-banner-page]')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const listen = (target, event, handler) => target?.addEventListener(event, handler, { signal: this.controller.signal });
      listen(this.querySelector('[data-banner-previous]'), 'click', () => this.go(this.index - 1));
      listen(this.querySelector('[data-banner-next]'), 'click', () => this.go(this.index + 1));
      this.pages.forEach((button, index) => listen(button, 'click', () => this.go(index)));
      listen(this.querySelector('[data-banner-pause]'), 'click', () => { this.paused = !this.paused; this.update(); this.schedule(); });
      listen(this.track, 'scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const edge = this.track.getBoundingClientRect().left;
          this.index = this.slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - edge) < Math.abs(this.slides[best].getBoundingClientRect().left - edge) ? index : best, 0);
          this.update(); this.schedule();
        }, 100);
      });
      listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      listen(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => { this.paused = this.motion.matches; this.update(); this.schedule(); });
      listen(document, 'shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.go(index, false); }
      });
      const controls = this.querySelector('.theme-image-banner__controls');
      if (controls) controls.hidden = this.slides.length < 2;
      this.update(); this.schedule();
    }
    disconnectedCallback() {
      this.controller.abort(); clearTimeout(this.timer); clearTimeout(this.scrollTimer);
    }
    go(index, smooth = true) {
      if (!this.slides.length) return;
      this.index = this.dataset.loop === 'true' ? (index + this.slides.length) % this.slides.length : Math.max(0, Math.min(index, this.slides.length - 1));
      const offset = this.slides[this.index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
      this.update(); this.schedule();
    }
    update() {
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.index;
        slide.setAttribute('aria-hidden', String(index !== this.index));
        slide.querySelectorAll('video').forEach((video) => {
          if (index === this.index && !this.motion.matches) video.play()?.catch(() => {});
          else video.pause();
        });
      });
      this.pages.forEach((page, index) => page.setAttribute('aria-current', String(index === this.index)));
      const previous = this.querySelector('[data-banner-previous]');
      const next = this.querySelector('[data-banner-next]');
      if (previous) previous.disabled = this.dataset.loop !== 'true' && this.index === 0;
      if (next) next.disabled = this.dataset.loop !== 'true' && this.index === this.slides.length - 1;
      const pause = this.querySelector('[data-banner-pause]');
      if (pause) { pause.setAttribute('aria-label', this.paused ? pause.dataset.playLabel : pause.dataset.pauseLabel); pause.querySelector('span').textContent = this.paused ? 'play_arrow' : 'pause'; }
      this.track.setAttribute('aria-live', this.dataset.autoplay === 'true' && !this.paused ? 'off' : 'polite');
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || document.hidden || this.slides.length < 2) return;
      if (this.index === this.slides.length - 1 && this.dataset.loop !== 'true') return;
      this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval));
    }
  });
}
